<script lang="ts" setup>
import { computed } from 'vue';

import { useBrowserStore } from '@apps/main/new-desktop/core/stores';
import { languageLocale } from '@apps/main/modules/localization/localeUtils';

import { AppFlicker } from '@libs/ui';

const browserStore = useBrowserStore();
const displayLongTextStyle = computed(
  () =>
    (languageLocale === 'de' ||
      languageLocale === 'fr' ||
      languageLocale === 'es') &&
    browserStore.isSmallerThan1536px &&
    browserStore.isLargerThan1199px
);
</script>

<template>
  <div class="hotel-selection-section-loader">
    <div class="top-section">
      <AppFlicker
        width="100%"
        height="spacing-16"
        border-radius="border-radius-8"
      />
      <AppFlicker
        width="100%"
        height="spacing-16"
        border-radius="border-radius-8"
      />
    </div>

    <div class="middle-section">
      <div class="first-element">
        <AppFlicker
          width="100%"
          height="spacing-16"
          border-radius="border-radius-8"
        />
        <AppFlicker
          width="100%"
          height="spacing-16"
          border-radius="border-radius-8"
        />
      </div>
      <div class="second-element">
        <AppFlicker
          width="100%"
          height="spacing-16"
          border-radius="border-radius-8"
        />
      </div>
    </div>

    <div
      :class="[
        'bottom-section',
        {
          mobile: browserStore.isSmallerThan900px,
          'is-long-text': displayLongTextStyle,
        },
      ]"
    >
      <AppFlicker
        width="100%"
        height="font-size-42"
        border-radius="border-radius-8"
      />

      <AppFlicker
        width="100%"
        height="font-size-42"
        border-radius="border-radius-8"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.hotel-selection-section-loader {
  background: var(--color-white);
  padding: var(--spacing-16);
  border: 1px solid var(--color-neutral-40);
  border-radius: var(--border-radius-8);
  margin-bottom: var(--spacing-16);

  .top-section {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);
    padding-bottom: var(--spacing-16);
    border-bottom: 1px solid var(--color-neutral-40);
  }

  .middle-section {
    display: flex;
    justify-content: space-between;
    align-items: end;

    padding-top: var(--spacing-16);
    padding-bottom: var(--spacing-8);
    margin-bottom: var(--spacing-16);

    .first-element {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-4);
      width: 150px;
    }

    .second-element {
      width: 90px;
    }
  }

  .bottom-section {
    display: flex;
    justify-content: space-between;
    gap: var(--spacing-16);

    &.mobile {
      flex-direction: column;
    }
  }
  .is-long-text {
    :first-child {
      flex: 1.5;
    }
    :last-child {
      flex: 2;
    }
  }
}
</style>
